import { observer } from 'mobx-react';
import integrationsStore from 'src/mobx/integrationStore';
import { localeStore } from 'src/mobx/localesStore';
import { TBooleanInNumber } from 'src/types/main';
import { isDisabledByPos } from 'src/utils/helpers';
import CustomTooltip, { TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import IntegrationTooltip from 'src/view/components/IntegrationTooltip/IntegrationTooltip';
import Text, { TEXT } from 'src/view/components/Text/Text';
import branchEditStore from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/store/branchEditStore';
import { appStore } from '~/mobx/appStore';
import { modalStore } from '~/mobx/modalStore';

const OrderSwitchers = observer(() => {
  const onChangeAvailabilityStatus = (status: TBooleanInNumber, cb?: () => void) => {
    if (appStore.settings?.donation.enabled && appStore.settings?.donation.branch_id === branchEditStore.editableBranch.id) {
      modalStore.openErrorModal({ message: localeStore.t('donation_branch_pickup') });
      return;
    }
    branchEditStore.changeBranchData({ status });
    cb?.();
  };

  const onChangePreorderStatus = (status: TBooleanInNumber) => branchEditStore.changeBranchData({ preorder: status });

  const branchAvailabilityRestrictionAccess = integrationsStore.posRestrictions?.branchAvailabilityChange;
  const isAvailabilityDisabledByPos = isDisabledByPos(branchAvailabilityRestrictionAccess);

  return (
    <div className="d-flex gap-40 mb-6">
      <IntegrationManager setting={branchAvailabilityRestrictionAccess} wrapperClassName="d-flex align-items-center">
        <IntegrationTooltip isVisible={isAvailabilityDisabledByPos}>
          <CustomTooltip
            message="select_branch_timeslot_first_errorenable_preorders_for_branch_toggle"
            tooltipClassName="bg-blur"
            messageClassName="text-size-14 color-red"
            wrapperClassName="cursor-not-allowed"
            position={TOOLTIP_POSITION.FIXED}
            show={!branchEditStore.editableBranch.working_time?.length}
          >
            <Switcher
              status={branchEditStore.editableBranch.status}
              onChange={onChangeAvailabilityStatus}
              hasCallback
              disabled={!branchEditStore.editableBranch.working_time?.length}
            />
          </CustomTooltip>
        </IntegrationTooltip>
        <Text type={TEXT.SWITCHER_LABEL} text="enable_orders_for_branch_toggle" disabled={isAvailabilityDisabledByPos} />
      </IntegrationManager>

      <div className="d-flex align-items-center gap-20">
        <Switcher status={branchEditStore.editableBranch.preorder} onChange={onChangePreorderStatus} />
        <p className="family-medium text-size-18">{localeStore.t('enable_preorders_for_branch_toggle')}</p>
      </div>
    </div>
  );
});

export default OrderSwitchers;
